import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { LIST_VIEW_ITEM } from 'config/types/content/component';
import { CONTENT_ITEM } from 'config/types/prop';
import { options } from 'config/reactRedux';
import { createGetComponentByContentItem } from 'selectors/createGetComponent';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './listViewItem.css';

const ListViewItem = ({
  item,
  component: ListViewItemComponent,
}) => (
  <div className={styles.wrapper}>
    <ListViewItemComponent item={item} />
  </div>
);

ListViewItem.propTypes = {
  item: PropTypes.shape(CONTENT_ITEM).isRequired,
  component: PropTypes.elementType.isRequired,
};

ListViewItem.defaultProps = {
  componentOverride: false,
};

const mapStateToProps = (state, props) => {
  const getComponent = createGetComponentByContentItem(
    props.item,
    LIST_VIEW_ITEM,
  );

  return {
    component: getComponent(state),
  };
};

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);
const wrapWithStyles = withStyles(styles);

export default withRedux(wrapWithStyles(ListViewItem));
